interface Identifiable {
  id: string | null;
}

export default class Util {
  public static removeNull<T>(value?: (T | null)[] | null): T[] {
    // if value is null return an empty array
    // remove null entries from array.
    let result: T[] = [];

    if (value) {
      result = value.flatMap(f => (f ? [f] : []));
    }

    return result;
  }

  public static itemId<T extends Identifiable>(item?: T | null): string {
    const result = item?.id ? item.id : "";

    return result;
  }
}
